import React from 'react';

export const NoteTextIconSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 3L3 3V21H17.159L21 17.159V3Z"
      fill="white"
    />
    <path
      d="M4 21C3.44771 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44771 21 4V17L17 21H4Z"
      stroke="#0A0D1B"
      strokeWidth="2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 21H15V17C15 15.8954 15.8954 15 17 15H21V17H17V21Z"
      fill="#0A0D1B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 17V15H13V17H7Z"
      fill="#0A0D1B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 13V11H17V13H7Z"
      fill="#0A0D1B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 9V7H17V9H7Z"
      fill="#0A0D1B"
    />
  </svg>
);
